import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import BookReader from './pages/bookReader';
import HomePage from './pages/homePage';
import PremiumPage from './pages/pricing';
import ContactUsPage from './pages/contactUs';
import PremiumDetailsPage from './pages/premiumDetails';
import FAQPage from './pages/faq';
import AuthoredBookReaderPage from './pages/authoredBookReader';
import AuthorHomePage from './pages/author/AuthorHomePage';
import AuthorWritePage from './pages/author/AuthorWritePage';
import ShopPage from './pages/shopPage';
import ResetPasswordPage from './pages/resetPassword';
import BlogsPage from './pages/blogs';
import BlogDetailPage from './pages/blogDetail';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/read_book/:book_id" element={<BookReader />} />
        <Route path="/read_authored/:book_id" element={<AuthoredBookReaderPage />} />
        <Route path="/author" element={<AuthorHomePage />} />
        <Route path="/author/write/:book_id" element={<AuthorWritePage />} />
        <Route path="/pricing" element={<PremiumPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/premium" element={<PremiumDetailsPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blogs/:slug" element={<BlogDetailPage />} />
      </Routes>
    </Router>
  );
}

export default App;
